import {
  EMPLOYER_BUILD_REQUEST,
  EMPLOYER_BUILD_SUCCESS,
  EMPLOYER_BUILD_FAIL,
  EMPLOYER_BUILD_RESET,
  EMPLOYER_BUILDLIST_REQUEST,
  EMPLOYER_BUILDLIST_SUCCESS,
  EMPLOYER_BUILDLIST_FAIL,
  EMPLOYER_ALLBUILDLIST_REQUEST,
  EMPLOYER_ALLBUILDLIST_SUCCESS,
  EMPLOYER_ALLBUILDLIST_FAIL,
  EMPLOYER_BUILDDETAIL_REQUEST,
  EMPLOYER_BUILDDETAIL_SUCCESS,
  EMPLOYER_BUILDDETAIL_FAIL,
  EMPLOYER_BUILDUPDATE_REQUEST,
  EMPLOYER_BUILDUPDATE_SUCCESS,
  EMPLOYER_BUILDUPDATE_FAIL,
  EMPLOYER_HIRE_REQUEST,
  EMPLOYER_HIRE_SUCCESS,
  EMPLOYER_HIRE_FAIL,
  EMPLOYER_HIRE_RESET,
  EMPLOYER_HIRELIST_REQUEST,
  EMPLOYER_HIRELIST_SUCCESS,
  EMPLOYER_HIRELIST_FAIL,
  EMPLOYER_ALLHIRELIST_REQUEST,
  EMPLOYER_ALLHIRELIST_SUCCESS,
  EMPLOYER_ALLHIRELIST_FAIL,
} from "../constants/employerConstants";

export const employerBuildReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYER_BUILD_REQUEST:
      return { loading: true };
    case EMPLOYER_BUILD_SUCCESS:
      return { loading: false, employerBuild: action.payload };
    case EMPLOYER_BUILD_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYER_BUILD_RESET:
      return {};
    default:
      return state;
  }
};

export const updateBuildEmployerReducer = (state = { job: {} }, action) => {
  switch (action.type) {
    case EMPLOYER_BUILDUPDATE_REQUEST:
      return { updateloading: true };
    case EMPLOYER_BUILDUPDATE_SUCCESS:
      return { updateloading: false, employerBuild: action.payload };
    case EMPLOYER_BUILDUPDATE_FAIL:
      return { updateloading: false, error: action.payload };
    // case EMPLOYER_BUILDUPDATE_RESET:
    //   return {};
    default:
      return state;
  }
};

export const listBuildEmployerReducer = (state = { jobs: [] }, action) => {
  switch (action.type) {
    case EMPLOYER_BUILDLIST_REQUEST:
      return { loading: true, jobs: [] };
    case EMPLOYER_BUILDLIST_SUCCESS:
      return {
        loading: false,
        jobs: action.payload,
      };
    case EMPLOYER_BUILDLIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const listAllBuildEmployerReducer = (state = { jobs: [] }, action) => {
  switch (action.type) {
    case EMPLOYER_ALLBUILDLIST_REQUEST:
      return { loading: true, jobs: [] };
    case EMPLOYER_ALLBUILDLIST_SUCCESS:
      return {
        loading: false,
        jobs: action.payload,
      };
    case EMPLOYER_ALLBUILDLIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const detailBuildEmployerReducer = (state = { job: {} }, action) => {
  switch (action.type) {
    case EMPLOYER_BUILDDETAIL_REQUEST:
      return { loading: true, job: {} };
    case EMPLOYER_BUILDDETAIL_SUCCESS:
      return {
        loading: false,
        job: action.payload,
      };
    case EMPLOYER_BUILDDETAIL_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const employerHireReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYER_HIRE_REQUEST:
      return { hireloading: true };
    case EMPLOYER_HIRE_SUCCESS:
      return { hireloading: false, employerHire: action.payload };
    case EMPLOYER_HIRE_FAIL:
      return { hireloading: false, hireerror: action.payload };
    case EMPLOYER_HIRE_RESET:
      return {};
    default:
      return state;
  }
};

export const listHireEmployerReducer = (state = { hire: [] }, action) => {
  switch (action.type) {
    case EMPLOYER_HIRELIST_REQUEST:
      return { hireloading: true, hire: [] };
    case EMPLOYER_HIRELIST_SUCCESS:
      return {
        hireloading: false,
        hire: action.payload,
      };
    case EMPLOYER_HIRELIST_FAIL:
      return { hireloading: false, error: action.payload };
    default:
      return state;
  }
};

export const listAllHireEmployerReducer = (state = { hire: [] }, action) => {
  switch (action.type) {
    case EMPLOYER_ALLHIRELIST_REQUEST:
      return { hireloading: true, hire: [] };
    case EMPLOYER_ALLHIRELIST_SUCCESS:
      return {
        hireloading: false,
        hire: action.payload,
      };
    case EMPLOYER_ALLHIRELIST_FAIL:
      return { hireloading: false, error: action.payload };
    default:
      return state;
  }
};
